// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left',
      suggestionMobileStyle: 'style2',
	}
};

(function() {
	BoostPFS.inject(this);

	// Pass 290P — embed product tags in the rendered <li> before it reaches the DOM so
	// hydrateInstantItem can do a pre-fetch suppression check without a second request.
	// Same pattern as ProductGridItem.prototype.compileTemplate in boost-pfs-filter.js.
	var _origInstantItemCompile = InstantSearchResultItemProduct.prototype.compileTemplate;
	InstantSearchResultItemProduct.prototype.compileTemplate = function() {
		var html = _origInstantItemCompile.call(this);
		if (html && this.data) {
			var tags = Array.isArray(this.data.tags) ? this.data.tags : [];
			var safeTags = tags.join(',').replace(/"/g, '&quot;');
			// data-b2b-instant-source confirms the override ran (QA marker).
			html = html.replace('data-id="' + this.id + '"',
				'data-id="' + this.id +
				'" data-boost-tags="' + safeTags +
				'" data-b2b-instant-source="InstantSearchResultItemProduct"');
		}
		return html;
	};

	// ── B2B instant suggestion price hydration ──────────────────────────────
	// Desktop instant search renders product suggestions via Boost's own JS.
	// For B2B customers the native Boost price is already hidden via CSS in
	// b2b-customer-handling.liquid (.boost-pfs-search-suggestion-product-price).
	// We watch the suggestion wrapper for new product items and hydrate B2B
	// prices from Shopify Section Rendering (same source as collection cards).
	//
	// Guard: only runs when window.customerData.loggedIn === true (B2B session).
	// Stale protection: data-b2b-instant-hydrated attr + li.isConnected check.
	// Loop prevention: items are marked 'pending' before slot append, so the
	// MutationObserver re-fire from our own DOM insertion is a no-op.

	function isB2BCustomer() {
		return !!(window.customerData && window.customerData.loggedIn === true);
	}

	// Pass 290P — mirrors isPriceSuppressedProduct() from boost-pfs-filter.js.
	// Reads tags from data-boost-tags (stamped by the compileTemplate override above).
	// email-for-price: always suppressed. add-to-cart-for-price: suppressed unless
	// gold-tier / platinum-tier (matches boost-card-price-renderer.liquid conditions).
	// Pass 290S — extract compare/current price text from the card renderer HTML and
	// rebuild using the exact same inner element structure as native logged-out desktop
	// instant search (boost-pfs-core.js lines 15465-15467): classless <s> for compare,
	// native Boost span class for current. Parent uses boost-b2b-instant-price (not the
	// native parent class which b2b-customer-handling.liquid hides for B2B).
	// UOM intentionally omitted — native instant template has none.
	function buildDesktopInstantPrice(priceNode) {
		var currentEl = priceNode.querySelector('.price-dozen .price-item .text-danger');
		if (!currentEl) return null;
		var compareEl = priceNode.querySelector('.price-each .price-item s');

		var currentText = currentEl.textContent.trim();
		var compareText = compareEl ? compareEl.textContent.trim() : '';

		var p = document.createElement('p');
		p.className = 'boost-b2b-instant-price';

		if (compareText) {
			var s = document.createElement('s');
			// No class on <s> -- matches native Boost instant template exactly.
			s.textContent = compareText;
			p.appendChild(s);
			p.appendChild(document.createTextNode(' ')); // non-breaking space, matches native template
		}

		var span = document.createElement('span');
		// Use native Boost instant span classes; scoped parent CSS applies color/style.
		span.className = compareText
			? 'boost-pfs-search-suggestion-product-sale-price'
			: 'boost-pfs-search-suggestion-product-regular-price';
		span.textContent = currentText;
		p.appendChild(span);

		return p;
	}

	function isInstantItemSuppressed(item) {
		var tagsRaw = item.getAttribute('data-boost-tags') || '';
		if (!tagsRaw) return false;
		var tags = tagsRaw.split(',').map(function(t) { return t.trim().toLowerCase(); });
		if (tags.indexOf('product-status:email-for-price') !== -1) return true;
		if (tags.indexOf('product-status:add-to-cart-for-price') !== -1) {
			var status = (window.customer && window.customer.status) || '';
			if (status !== 'gold-tier' && status !== 'platinum-tier') return true;
		}
		return false;
	}

	function hydrateInstantItem(item) {
		if (item.getAttribute('data-b2b-instant-hydrated')) return;

		// Pass 290P — skip suppressed products before creating slot or fetching.
		if (isInstantItemSuppressed(item)) {
			item.setAttribute('data-b2b-instant-hydrated', 'suppressed');
			return;
		}

		var link = item.querySelector('a[href*="/products/"]');
		if (!link) return;
		var href = (link.getAttribute('href') || '').split('?')[0].split('#')[0];
		var match = href.match(/\/products\/([^/]+)/);
		if (!match) return;
		var handle = match[1];

		var right = item.querySelector('.boost-pfs-search-suggestion-right');
		if (!right) return;

		// Mark processed before appending (prevents observer re-fire loop)
		item.setAttribute('data-b2b-instant-hydrated', 'pending');

		var slot = document.createElement('div');
		slot.className = 'boost-b2b-instant-price-slot';
		slot.innerHTML = '<div class="boost-b2b-price-skeleton" aria-hidden="true"></div>';
		right.appendChild(slot);

		window.boostB2BPriceHydration.fetchRenderedPrice(handle)
			.then(function (html) {
				if (!item.isConnected) return;
				item.setAttribute('data-b2b-instant-hydrated', 'true');
				if (!html) { slot.innerHTML = ''; return; }
				var parser = new DOMParser();
				var doc = parser.parseFromString(html, 'text/html');
				var priceNode = doc.querySelector('[data-boost-card-rendered-price]');
				if (!priceNode || !priceNode.innerHTML.trim()) { slot.innerHTML = ''; return; }
				// Pass 290R: build native instant price markup instead of injecting
				// the full card renderer block (which uses collection-card sizing/classes).
				var priceEl = buildDesktopInstantPrice(priceNode);
				if (!priceEl) { slot.innerHTML = ''; return; }
				slot.innerHTML = '';
				slot.appendChild(priceEl);
			})
			.catch(function () { if (slot.isConnected) slot.innerHTML = ''; });
	}

	function hydrateInstantSuggestions() {
		if (!isB2BCustomer()) return;
		if (!window.boostB2BPriceHydration ||
				typeof window.boostB2BPriceHydration.fetchRenderedPrice !== 'function') return;

		var items = document.querySelectorAll(
			'.boost-pfs-search-suggestion-item-product:not([data-b2b-instant-hydrated])'
		);
		Array.prototype.slice.call(items).forEach(function (item) {
			hydrateInstantItem(item);
		});
	}

	var _instantObserver = null;

	function setupInstantObserver() {
		if (_instantObserver) return;

		_instantObserver = new MutationObserver(function (mutations) {
			for (var i = 0; i < mutations.length; i++) {
				if (mutations[i].addedNodes.length > 0) {
					hydrateInstantSuggestions();
					return;
				}
			}
		});

		function tryAttach() {
			var wrapper = document.querySelector('.boost-pfs-search-suggestion-wrapper');
			if (wrapper) {
				_instantObserver.observe(wrapper, { childList: true, subtree: true });
				// Scan items that Boost may have already rendered into the wrapper
				// before the observer attached (first-type on fast connections).
				hydrateInstantSuggestions();
				return true;
			}
			return false;
		}

		if (!tryAttach()) {
			// Wrapper not in DOM yet — watch body until it appears
			var findObserver = new MutationObserver(function () {
				if (tryAttach()) findObserver.disconnect();
			});
			findObserver.observe(document.body, { childList: true, subtree: true });
		}
	}

	// ── Boost hooks ─────────────────────────────────────────────────────────

	SearchInput.prototype.customizeInstantSearch = function() {
		if (!isB2BCustomer()) return;
		setupInstantObserver();
	};

	SearchInput.prototype.afterBindEvents = function() {
		// Pass 290Q — reliable observer bootstrap. customizeInstantSearch() is called
		// only from _bindAutoCompleteResizeMenu (fires on menu resize, not on render),
		// so the observer never attached on desktop during normal use. afterBindEvents
		// fires once per SearchInput instance during component init — safe and reliable.
		if (isB2BCustomer()) setupInstantObserver();

		// Fix cannot close search suggestion when clicking overlay
		document.addEventListener('click', function(e) {
			if(this.searchAutoComplete && this.searchAutoComplete.isOpen && e && e.target) {
				var $clickedElement = jQ(e.target);
				var isClickSuggestion = $clickedElement.closest('.' + Class.searchSuggestionWrapper).length > 0;
				if (isClickSuggestion) {
					this.searchAutoComplete.$element.hide();
					this.searchAutoComplete.searchInput.onCloseAutocomplete();
					this.searchAutoComplete.isOpen = false;
				}
			}
		}.bind(this), true);
	}
})();
